angular.module('impactx.panel').directive('ixThemeworldPreviewPanel', ThemeworldPreviewPanelDirective);

function ThemeworldPreviewPanelDirective() {
    return {
        restrict: 'EA',
        controller: 'ThemeworldPreviewPanelCtrl',
        controllerAs: 'themeworldPreviewPanelCtrl',
        scope: true,
        bindToController: {
            name: "=",
            image: "=",
            themeworld: "=",
            trns: "=",
            color: "="
        },
        templateUrl: 'shared/panel/templates/themeworld.preview.panel.tmpl.html'
    }
}